import { useFormatter, useTranslations } from "@zapier/i18n";
import type { AssetSearchErrorMessages } from "@zapier/global-search";

export function useAssetSearchErrorMessages(): AssetSearchErrorMessages {
  const t = useTranslations("global-search-error");
  const products = useTranslations("global-search-error.products");
  const format = useFormatter();

  return {
    retryLabel: t("retry"),
    formatMessage(failedAssetTypes) {
      if (failedAssetTypes.length === 0) return t("generic");

      const names = failedAssetTypes.map((type) => products(type));
      return t("named", {
        products: format.list(names, { type: "conjunction" }),
      });
    },
  };
}
